/**
 * Header icon + logo
 */
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import { ReactNode } from 'react';
import { openSideMenu } from 'store/actions/sidemenu.actions';

import { useLanguage } from '../../../../hooks/useLanguage';
import A from '../../../Link/Link';
import { useDropHomePageCache } from '../../../PageHome/PageHome';
import HeaderItem from '../HeaderItem';

type Props = {
  icon?: ReactNode | 'home' | 'back';
  // If "iconOnClick" returns true, default functionality will be called after calling "iconOnClick"
  iconOnClick?: (history: Array<string>) => boolean;
  showLogo?: boolean;
  price?: string | JSX.Element;
  children?: ReactNode;
  className?: string;
  history?: Array<string>;
  isDevelopment?: boolean;
  goBack: () => void;
};

export const HeaderIconLogo = (props: Props) => {
  const { icon, showLogo, iconOnClick, children, className, history, price, isDevelopment, goBack } = props;

  const { language, country, availableLanguages } = useLanguage();

  const currentLanguageIndex = availableLanguages?.findIndex((l) => l === language);
  const dropHomePageCache = useDropHomePageCache();

  // Logo options
  const logoOption = showLogo === undefined ? true : showLogo;

  // Icon + action options
  let iconOption;
  let clickFn;

  switch (icon) {
    case 'home': {
      iconOption = <MenuIcon />;
      clickFn = () => (typeof iconOnClick === 'function' ? iconOnClick(history) && openSideMenu(true) : openSideMenu(true));
      break;
    }
    case 'back': {
      iconOption = <ArrowBackIcon />;
      clickFn = () => (typeof iconOnClick === 'function' ? iconOnClick(history) && goBack() : goBack());
      break;
    }
    default:
      iconOption = icon || <MenuIcon />;
      clickFn = () => (icon ? typeof iconOnClick === 'function' && iconOnClick(history) && goBack() : openSideMenu(true));
  }

  return (
    <HeaderItem className={className}>
      {/* MENU BUTTON */}
      {iconOption && (
        <IconButton edge="start" onClick={clickFn}>
          {iconOption}
        </IconButton>
      )}

      {/* LOGO */}
      {logoOption && (
        <A href="/" as="/" className="logo-link" onClick={() => dropHomePageCache()}>
          <img className="logo" alt="logo" src="/logo.svg" />
          {
            // Mark and language switch for development only
            isDevelopment && (
              <div className="development">
                development
                <div className="development-locale">
                  <div className="development-language">{availableLanguages[currentLanguageIndex]}</div>
                  <div className="development-country">{country}</div>
                </div>
              </div>
            )
          }
        </A>
      )}

      <span className="header-icon-text">
        {children}
        {price && <span className="header__price">{price}</span>}
      </span>
    </HeaderItem>
  );
};
